class BaseError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = new.target.name
  }
}

// auth-api がプラン変更を上限超過で拒否したときの 1 件分
// （auth-api #1215 の Billing::PlanDowngradeGate / #1182 の
// ContentTypeDowngradeGate）。
export type QuotaExceededErrorItem = {
  code: string
  metadata?: {
    product_name?: string
    current?: number
    limit?: number
    plan_name?: string
  }
}

export class NetworkUnauthorizedError extends BaseError {
  // 422 が上限超過だったときだけ入る。**instanceof には頼らない**
  // （target: es5 で Error を継承しているので、ビルド系によって
  // instanceof の結果が変わりうる）。読む側は helpers/quotaExceededMessage
  // の quotaExceededErrorsOf を使い、**この値が載っているか**だけを見る。
  quotaErrors?: QuotaExceededErrorItem[]
}

export class UnknownNetworkError extends BaseError {}

export class SerializeFailureError extends BaseError {
  constructor(message = "Cannot serialize object.") {
    super(message)
  }
}

export class UnknownError extends BaseError {}
